import api from './api';

/**
 * @param {string} testId
 * @returns {Promise<{
 *  test_group_id: string
 *  name: string
 *  qpvSet: string
 *  status: string
 *  tests: {
 *      test_id: string
 *      qpv_reference: string
 *      is_published: boolean
 *      skill_id: 'speaking' | 'reading_writing' | 'listening'
 *      test_threshold: {
 *          test_threshold_id: string
 *          shield_1: number
 *          shield_2: number
 *          shield_3: number
 *          shield_4: number
 *          shield_5: number
 *      }[]
 *  }[]
 *  test_focuses_thresholds: {
 *      tf_threshold_id: string
 *      threshold: number
 *      test_focuses: {
 *          tf_id: string
 *          tag: string
 *          name: string
 *          strengths_in_english: string
 *          here_are_some_things: string
 *          what_can_i_do: string
 *      }
 *  }[]
 * }>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-TestGroups-getOneTestGroup
 */
export default async function getTest(level_id, testId) {
    const { data } = await api.get(`levels/${level_id}/test_groups/${testId}`);

    return data;
}